import { render } from "./Coupon01.vue?vue&type=template&id=62380123"
import script from "./Coupon01.vue?vue&type=script&lang=js"
export * from "./Coupon01.vue?vue&type=script&lang=js"

import "./Coupon01.vue?vue&type=style&index=0&id=62380123&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__